// extracted by mini-css-extract-plugin
export default {"container":"NoEdit_container__+rnz7","text":"NoEdit_text__2akw0","timer__text":"NoEdit_timer__text__ya-2U","text__block":"NoEdit_text__block__2OYti","button":"NoEdit_button__XQy3L"};